import type { ReactNode } from "react";
import type { ConfirmOptions } from "@jkast90/kast-common/ui";

/**
 * The question every delete asks through kast-common's `useConfirm`:
 * "Are you sure you want to delete X?", with a danger Delete button.
 */
export function deleteQuestion(itemName: ReactNode): ConfirmOptions {
  return {
    title: "Confirm Delete",
    message: (
      <>
        Are you sure you want to delete <strong>{itemName}</strong>?
      </>
    ),
    confirmLabel: "Delete",
    danger: true,
  };
}
